import styled from '@emotion/styled'

const Content = styled.div`
  width: 100%;
  max-width: 48rem;
  padding: 0 1.5rem;
`

export default Content
